import useTranslation from "../../client/hooks/useTranslation";

/** Challenge proposé comme origine d'un compte funded (fundedLineage.ts). */
export interface PredecessorOption {
  id: string;
  name: string;
  status: string;
  targetReached: boolean;
  size: number;
}

/** Libellé d'un challenge proposé : nom, taille, et ce qui le rend probable. */
export default function PredecessorLabel({ option, suggested }: { option: PredecessorOption; suggested?: boolean }) {
  const t = useTranslation();
  const tags = [
    option.targetReached ? t.fundedLineage.targetReached : null,
    option.status === "inactive" ? t.fundedLineage.inactiveTag : null,
    suggested ? t.fundedLineage.importSuggested : null,
  ].filter(Boolean);
  return (
    <span className="flex items-center gap-2">
      <span className="font-mono">{option.name}</span>
      <span className="font-mono text-muted-foreground">{Math.round(option.size).toLocaleString()}</span>
      {tags.length > 0 && <span className="text-xs text-muted-foreground">({tags.join(", ")})</span>}
    </span>
  );
}
